import { getSortedModules } from "./index156.js";
import { tryInsertSpace } from "./index141.js";
function tryInsertSpaces(spaces, apartmentArray, apartmentIndex, moduleIndex = 0) {
  let invalid = 0;
  let unusedArea = 0;
  if (moduleIndex !== 0) {
    const modules = getSortedModules(apartmentArray, apartmentIndex);
    for (let i = 0; i < moduleIndex; i++) {
      unusedArea += modules[i].size[0] * modules[i].size[2];
    }
  }
  const leftoverSpaces = [...spaces];
  for (const space of spaces) {
    const result = tryInsertSpace(space, apartmentIndex, moduleIndex, apartmentArray);
    if (!result.success && result.outOfBounds === "PosJ") {
      break;
    }
    if (!result.success) {
      invalid++;
    } else {
      unusedArea += result.unusedArea;
      apartmentIndex = result.newPos.apartmentIndex;
      moduleIndex = result.newPos.moduleIndex;
    }
    leftoverSpaces.shift();
  }
  if (moduleIndex !== 0) {
    const modules = getSortedModules(apartmentArray, apartmentIndex);
    for (let i = moduleIndex; i < modules.length; i++) {
      unusedArea += modules[i].size[0] * modules[i].size[2];
    }
  }
  return { unusedArea, invalid, leftoverSpaces };
}
export {
  tryInsertSpaces
};
//# sourceMappingURL=index142.js.map
